// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false;
import $ from "jquery";
window.$ = $;
import '@/assets/css/bootstrap.css';
import 'open-iconic/font/css/open-iconic-bootstrap.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap';
import 'element-ui/lib/index.js';
import Element from 'element-ui';
Vue.use(Element,{size:"small"});
import '@/assets/css/element.css';
// import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/icon.css';
import '@/assets/css/display.css';
import '@/assets/css/common.css';
import Pagination from "@/components/Pagination";
import * as mercyStore from '@/assets/js/mercyStore.js';
window.mercyStore = mercyStore;

import Bus from "@/Bus"
Vue.prototype.bus = Bus

import axios from 'axios';
Vue.prototype.axios = axios;
window.axios = axios;
// 全局引入markdown编辑器
import { mavonEditor } from "mavon-editor";
import "mavon-editor/dist/css/index.css";

Vue.component("mavon-editor", mavonEditor);
Vue.component('Pagination', Pagination)
let isEn = sessionStorage.getItem("isEn");
if (isEn == '' || isEn == null || isEn == undefined){
  let str = window.location.href;
  let index = str.lastIndexOf("\/");
  let en = str.substring(index + 1, str.length);
  if ('en' == en){
    isEn = '1'
  } else {
    isEn = '0'
  }
}
$.ajax({
  type: "get",
  url: `${window.$server_config.VUE_APP_WEBSITE_API}outer/dict/data/type/website_pic_type`,
  async:false,
  success: function(res){
    if(res.code == 200){
      let picType=res.data;
      $.ajax({
        type: "get",
        url: `${window.$server_config.VUE_APP_WEBSITE_API}outer/picInfo/getPicList?isEn=`+isEn,
        async:false,
        success: function(res){
          if(res.code == 200){
            picType.forEach(element => {
              element.children=res.data.filter(t=> t.picType==element.dictValue)
            });
            Vue.prototype.$picData = picType;
          }
        }
      });
    }
  }
});

new Vue({
  el: '#app',
  router,
  data:{
    hasShow:true,
  },
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js